export const getFloatingBannerStyle = () => ({
  floatingBanner: {
    position: 'fixed',
    bottom: '10%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: '#fff',
    width: 650,
    zIndex: 100,
  },
});
